// src/ui/features/calculator/components/SidePanelActions.jsx
import React from "react";
import { PayPalIcon, CrownIcon } from "../../primatives/Icons";

export default function SidePanelActions({
  exportLocked = false,
  onExport,
  onRequestPro,
}) {
  const onClickExport = () => {
    if (exportLocked) {
      onRequestPro?.();
      return;
    }
    onExport?.();
  };

  return (
    <div className="grid grid-cols-2 gap-2">
      {/* Export (utility) */}
      <button
        type="button"
        onClick={onClickExport}
        aria-disabled={exportLocked}
        title={exportLocked ? "Pro feature" : "Export"}
        className="
          relative flex w-full items-center
          rounded-2xl border border-neutral-200 bg-white px-4 py-3
          text-sm font-semibold text-neutral-800
          hover:bg-neutral-100
          dark:border-neutral-800 dark:bg-neutral-900 dark:text-neutral-100 dark:hover:bg-neutral-800
        "
      >
        {/* Centered label */}
        <span className="absolute inset-0 flex items-center justify-center">
          Export&nbsp;
        </span>
      
        {/* Right aligned Pro badge */}
        {exportLocked ? (
          <span className="ml-auto inline-flex items-center gap-0.5 rounded-full bg-orange-500/15 px-2 py-0.5 text-[11px] font-semibold text-orange-600 dark:text-orange-300">
            <CrownIcon className="h-3 w-3" />
            Pro
          </span>
        ) : null}
      </button>

      {/* Donate (monetisation) */}
      <a
        href="https://www.paypal.com/donate/?hosted_button_id=UHUNQVDR2S2X4"
        target="_blank"
        rel="noopener noreferrer"
        className="
          flex w-full items-center justify-center gap-2
          rounded-2xl bg-orange-500 px-4 py-3
          text-sm font-semibold text-white
          hover:bg-orange-600
          focus:outline-none focus:ring-2 focus:ring-orange-400
        "
        aria-label="Donate via PayPal"
      >
        <PayPalIcon className="h-5 w-5" />
        <span>Donate</span>
      </a>
    </div>
  );
}
